var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWire = function SvgWire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_201737)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2658 5.3334C15.2658 2.79289 13.2063 0.733398 10.6658 0.733398H5.33242C2.79191 0.733398 0.732422 2.79289 0.732422 5.3334V10.6667C0.732422 13.2072 2.79191 15.2667 5.33242 15.2667H10.6658C13.2063 15.2667 15.2658 13.2072 15.2658 10.6667V5.3334ZM10.6658 1.9334C12.5435 1.9334 14.0658 3.45563 14.0658 5.3334V10.6667C14.0658 12.5445 12.5435 14.0667 10.6658 14.0667H5.33242C3.45465 14.0667 1.93242 12.5445 1.93242 10.6667V5.3334C1.93242 3.45563 3.45465 1.9334 5.33242 1.9334H10.6658Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2201 6.89634C11.1272 7.12055 10.9084 7.26673 10.6658 7.26673H5.33242C5.00105 7.26673 4.73242 6.9981 4.73242 6.66673C4.73242 6.33536 5.00105 6.06673 5.33242 6.06673L9.21723 6.06673L8.90816 5.75766C8.67384 5.52335 8.67384 5.14345 8.90816 4.90913C9.14247 4.67482 9.52237 4.67482 9.75669 4.90913L11.09 6.24247C11.2616 6.41407 11.313 6.67214 11.2201 6.89634Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7794 9.10444C4.87227 8.88024 5.09105 8.73405 5.33373 8.73405H10.6671C10.9984 8.73405 11.2671 9.00268 11.2671 9.33405C11.2671 9.66542 10.9984 9.93405 10.6671 9.93405H6.78225L7.09132 10.2431C7.32564 10.4774 7.32564 10.8573 7.09132 11.0916C6.85701 11.326 6.47711 11.326 6.24279 11.0916L4.90946 9.75832C4.73786 9.58672 4.68653 9.32865 4.7794 9.10444Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_201737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "wire.89a583cd91fb5ee56a0c5c749bfd67ba.svg";